import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Utils } from 'src/app/Models/Classes/utils';
import { InputAlertControllerService } from 'src/app/services/utils/input-alert-controller.service';
import { WalletServiceService } from 'src/app/services/wallet/wallet-service.service';
import {RequestService} from "src/app/services/request/request.service";
import Swal2 from "sweetalert2";
import { FriendshipService } from 'src/app/services/relations/relations.service';
import { PublicationClass } from 'src/app/Models/Classes/Publications/publication-class';
import { StoryViewerComponent } from 'src/app/components/stories-bar/story-viewer/story-viewer.component';
import { PublicationService } from 'src/app/services/publications/publication.service';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { Subscription } from 'rxjs';
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
	@Input() followButton: any = {
		followButton: {
			text: 'Siguiendo',
			error: false,
		},
	};
  @Input() fromwhere:string ;
	@Input() profilePhoto: any;
	@Input() userName: string;
	@Input() createdAt: number;
	@Input() owner: boolean = false;
	@Input() user_id: any;
	@Input() profile_id: any;
	@Input() discardInteractions: boolean;
	@Input() corp: boolean = false;
	public timeSincePublish: string = "Justo ahora";
	completePictureUrl: string = 'assets/icon/usuario.png';
	public authorStories: Array<PublicationClass> = [];
	public hasAuthorStories = false;
	public hasUnseenAuthorStories = false;
	public allAuthorStoriesSeen = false;
	private storiesSubscription: Subscription;
	private storyRequestSequence = 0;
	isKYCValid: boolean = false;
	@Output() sharePublication = new EventEmitter();
	@Output() editPublication = new EventEmitter();
	@Output() deletePublication = new EventEmitter();

	constructor(
		private navCtrl: NavController,
		private utils: Utils,
		private inputAlertController: InputAlertControllerService,
		public walletService: WalletServiceService,
		private request: RequestService,
		private friendshipService: FriendshipService,
		private modalCtrl: ModalController,
		private publicationService: PublicationService,
		private formService: FormServiceService,
		private changeDetector: ChangeDetectorRef,
	) { }

	get followButtonText(): string {
		return this.followButton?.followButton?.text || 'Siguiendo';
	}

	ngOnInit() {
		//console.log('followButton', this.followButton);
		//console.log('owner', this.owner);
		console.log('followButton2', this.followButton?.followButton?.error);
		this.utils.calcularTiempo(this.createdAt).then(time => {
			this.timeSincePublish = time;
			
		});
		this.completePictureUrl = this.resolveProfilePhoto(this.profilePhoto);
		this.refreshAuthorStories();
		this.storiesSubscription = this.publicationService.storiesChanged$.subscribe(() => {
			this.refreshAuthorStories();
			this.changeDetector.markForCheck();
		});
		this.loadAuthorStories();
		this.publicationService.loadStories().catch(() => {
			// Keep the existing publication header available if Stories cannot load.
		});
		console.log('Profile Photo URL:', this.profilePhoto);
		//this.walletService.KYC_validation3(this.user_id).then((result_kyc) => {
		//	console.log('KYC_validation result:', result_kyc);
	//	  if (result_kyc['permit']) {
	//		this.isKYCValid = true;
	//	  }
	//	});



	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['profilePhoto']) {
			this.completePictureUrl = this.resolveProfilePhoto(this.profilePhoto);
		}

		if (changes['user_id'] || changes['profile_id'] || changes['userName']) {
			this.refreshAuthorStories();
			this.loadAuthorStories();
		}
	}

	ngOnDestroy(): void {
		this.storiesSubscription?.unsubscribe();
	}

	private resolveProfilePhoto(profilePhoto: any): string {
		let source = profilePhoto;
		for (let depth = 0; depth < 3 && source && typeof source === 'object'; depth++) {
			const nestedPhoto = this.firstValue(
				source.url,
				source.route,
				source.path,
				source.src,
				source.localUrl,
				source.photo_url,
				source.photoUrl,
				source.profile_photo,
				source.profilePhoto,
			);
			if (nestedPhoto === source) {
				break;
			}
			source = nestedPhoto;
		}

		const value = typeof source === 'string' ? source.trim() : '';
		if (!value || value === 'null' || value === 'undefined') {
			return 'assets/icon/usuario.png';
		}

		if (/^(https?:|blob:|data:|capacitor:|file:)/i.test(value) || value.startsWith('assets/')) {
			return value;
		}

		return 'https://laniakea-multimedia.s3.amazonaws.com/' + value.replace(/^\/+/, '');
	}

	public onAvatarClick(event: Event): void {
		event?.stopPropagation();

		if (this.hasAuthorStories) {
			this.openAuthorStories();
			return;
		}

		// Keep the existing header action when the author has no active Stories.
		if (this.owner || this.followButtonText !== 'Seguir') {
			this.Click_On_User();
		} else {
			this.buttonsActions(this.followButton);
		}
	}

	public onAvatarKeydown(event: KeyboardEvent): void {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.onAvatarClick(event);
		}
	}

	public get avatarAriaLabel(): string {
		const authorName = this.userName || 'este usuario';
		if (this.hasAuthorStories) {
			return this.hasUnseenAuthorStories
				? `Abrir historias nuevas de ${authorName}`
				: `Volver a ver historias de ${authorName}`;
		}

		return (!this.owner && this.followButtonText === 'Seguir')
			? `Seguir a ${authorName}`
			: `Abrir perfil de ${authorName}`;
	}

	public handleProfileImageError(event: Event): void {
		const image = event.target as HTMLImageElement | null;
		if (image && image.getAttribute('src') !== 'assets/icon/usuario.png') {
			image.src = 'assets/icon/usuario.png';
		}
	}

	private openAuthorStories(): void {
		if (!this.authorStories.length) {
			return;
		}

		this.modalCtrl.create({
			component: StoryViewerComponent,
			cssClass: 'detailsInModal',
			canDismiss: true,
			componentProps: {
				stories: this.authorStories,
				tapped: 0,
			}
		}).then(modal => modal.present()).catch(error => {
			console.error('Error opening author Stories:', error);
		});
	}

	private refreshAuthorStories(): void {
		this.authorStories = this.publicationService.getStoriesForAuthor(
			[this.user_id],
			[this.userName],
			this.profilePhoto,
			[this.profile_id],
		);
		this.updateAuthorStoryIndicator();
	}

	private loadAuthorStories(): void {
		const requestSequence = ++this.storyRequestSequence;
		this.publicationService.loadStoriesForAuthor(
			this.profile_id,
			[this.user_id],
			[this.userName],
			this.profilePhoto,
		).then(stories => {
			if (requestSequence !== this.storyRequestSequence) {
				return;
			}

			this.authorStories = Array.isArray(stories) ? stories : [];
			this.updateAuthorStoryIndicator();
			this.changeDetector.markForCheck();
		}).catch(() => {
			// Keep the existing profile/follow action available when the optional
			// targeted Stories lookup is unavailable.
		});
	}

	private updateAuthorStoryIndicator(): void {
		this.hasAuthorStories = this.authorStories.length > 0;
		this.hasUnseenAuthorStories = this.publicationService.hasUnseenStories(
			this.authorStories,
			this.formService.profile,
		);
		this.allAuthorStoriesSeen = this.publicationService.areAllStoriesSeen(
			this.authorStories,
			this.formService.profile,
		);
	}

	private firstValue(...values: any[]): any {
		return values.find(value =>
			value !== null &&
			value !== undefined &&
			!(typeof value === 'string' && !value.trim())
		);
	}

  returnclass(){
    if((this.fromwhere === "lkfilm") || (this.fromwhere==="webview")){
      return "transparent-95"
    }else{
      return "transparent"
    }

  }

	moreActionSheet() {
		let buttons = new Array<any>();
		buttons.push({text: 'Compartir', icon: 'share'});

		if (this.owner) {
			buttons.push({text: 'Editar', icon: 'create'});
			buttons.push({text: 'Eliminar', icon: 'trash'});
		}
		this.inputAlertController.SelectorActionSheet(buttons, 'Opciones de publicación').then((result)=>{
			if(result['action']){
				switch(result['button']['text']){
					case 'Compartir': {
						this.sharePublication.emit();
						break;
					}
					case 'Editar': {
						this.editPublication.emit();
						break;
					}
					case 'Eliminar': {
						this.deletePublication.emit();
						break;
					}
					default: break;
				}
			}
		}).catch((error)=>{
			console.error(error);
		});
	}

	Click_On_User() {
    console.log('click header to send to user profile page');
		//if(!this.discardInteractions){
			this.navCtrl.navigateForward('home/profile/' + this.user_id);
		//}
	}
	click_FollowButton(button_info) {

		//switch (this.followButton['text']) {
		//	case "Seguir":
				this.buttonsActions(button_info);
		//		break;
		//	case "Siguiendo":
				//this.buttonsActions(button_info);
		//		break;
		//}
	}
	buttonsActions(button_info){
		console.log('click header follow');
console.log(button_info);
		//if(button_info['type'] == 3){
			//switch (button_info.text) {
				//case "Seguir":
					this.createRelation(3).then((data)=>{
						this.utils.presentToast("You are now following user ");
						this.followButton['text']="Siguiendo";
				//	});
				//	break;
				//case "Siguiendo":
				//	this.deleteRelation(button_info['relation_id']).then((data)=> {
				//		this.utils.presentToast("You stopped following user ");
				//		this.followButton['text']="Seguir";
				//	});
				//	break;
			})
		//}
	}
	createRelation(relation_type): Promise<any>{
		return new Promise((resolve, reject) => {
			let newRelation = {
				'relationUserId': this.user_id.toString(),
				'relationType': '3'
			};
			this.sendNotification( );
			this.friendshipService.createRelation(newRelation).then((result)=>{
				result = JSON.parse(result);
				switch (relation_type) {
					case 3:
						this.followButton.relation_id = result.relation_id;
						break;

					default:
						break;
				}
				resolve(result);
			}).catch((error) =>{
				reject(error);
			});
		});

	}
	sendNotification() {
   
		return new Promise((resolve, reject) => {
		  const notification = {
			title: 'Nuevo seguidor asequido',
			body: `¡Has recibido un nuevo seguidor en tu perfil!`,
			user_id:this.user_id,
	
		  };
	  
		  this.request.createRequestPost('GreatAtractorNotifications', notification)
			.then((data) => {
				
			  resolve(data);
			}).catch((error) => {
			  console.error('Failed to send notification:', error);
			  reject(error);
			});
		});
	  }
	  deleteRelation(relation_id):Promise<any>{
		return new Promise((resolve, reject) => {
			let params = {
				'id': relation_id.toString(),
			};
			this.friendshipService.deleteRelation(params).then((result) => {
				resolve(result);
			}).catch((error) =>{
				reject(error);
			});
		});

	}

}
